import { render, staticRenderFns } from "./sellerInfo.vue?vue&type=template&id=0578836c&scoped=true&"
import script from "./sellerInfo.vue?vue&type=script&lang=js&"
export * from "./sellerInfo.vue?vue&type=script&lang=js&"
import style0 from "./sellerInfo.vue?vue&type=style&index=0&id=0578836c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0578836c",
  null
  
)

export default component.exports